<!-- chatbot.component.html -->
<div class="chatbot-wrapper">
  <!-- Chatbot Toggle Button -->
  <button class="chatbot-toggle" 
          [class.expanded]="isExpanded"
          (click)="toggleChatbot()"
           [title]="isExpanded ? 'Close chat' : 'Open chat'"
          [@bounceIn]>
    <div class="toggle-icon">
      <!-- Chat Icon -->
      <svg *ngIf="!isExpanded" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v3c0 .6.4 1 1 1h.5c.2 0 .5-.1.7-.3L16.5 18H20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 12H7c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1zm0-3H7c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1zm0-3H7c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1z"/>
      </svg>
      <!-- Close Icon -->
      <svg *ngIf="isExpanded" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    </div>
    <span *ngIf="!isExpanded" class="toggle-text"></span>
  </button>

  <!-- Chatbot Container -->
  <div class="chatbot-container" 
       [@slideInOut]="animationState"
       *ngIf="isExpanded || animationState === 'in'">
    
    <!-- Header -->
    <div class="chatbot-header">
      <div class="header-content">
        <div class="bot-avatar">
          <!-- Bot Avatar Icon -->
          <svg width="20" height="20" viewBox="0 0 100 100" fill="white">
            <rect x="20" y="25" width="60" height="50" rx="15" ry="15" fill="currentColor" opacity="0.9"/>
            <circle cx="37" cy="40" r="4" fill="#667eea"/>
            <circle cx="63" cy="40" r="4" fill="#667eea"/>
            <rect x="42" y="55" width="16" height="6" rx="3" ry="3" fill="#667eea"/>
          </svg>
          <!-- <span class="logo"><img src="assets/newimages/myecolabAgent.png" alt="ECOLAB"  width="24px" height="24px"></span> -->
        </div>
        <div class="header-info">
          <h3>AI Assistant</h3>
          <p class="status">
            <span class="status-dot" [class.offline]="!isConnected"></span>
            
          </p>
        </div>
      </div>
      <div class="header-actions">
        <button class="clear-btn" 
                (click)="clearConversation()" 
                title="Clear conversation"
                *ngIf="messages.length > 0">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3 6v18h18v-18h-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10z"/>
          </svg>
        </button>
        <button class="minimize-btn" (click)="toggleChatbot()" title="Minimize Chat">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 13H5v-2h14v2z"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Messages Container -->
    <div class="messages-container" #messagesContainer>
    <div class="messages-list">
     <div class="welcome-message" *ngIf="messages.length === 0">
  <div class="bot-message">
    <!-- <div class="message-avatar bot-avatar-msg">🤖</div> -->
    <div class="message-content welcome-content">
      <div class="welcome-header">
        <h6>Welcome to Order Tracking Assistant!</h6>
      </div>
      <p>I can assist you with:</p>
      <ul class="feature-list">
        <li class="feature-item">
          <!-- <span class="feature-icon">📦</span> -->
          <span>Check the delivery ETA by entering the delivery number or order number.</span>
        </li>
        <li class="feature-item">
          <!-- <span class="feature-icon">🕒</span> -->
          <span>Get territory details by entering an email address.</span>
        </li>
        <li class="feature-item">
          <!-- <span class="feature-icon">💬</span> -->
          <span>Create support incident</span><br>
          Incident request : <a href="https://ecolab.service-now.com/myecolab?id=sc_cat_item&sys_id=f6e771241be55498eef54377cc4bcbb0" target="_blank" class="support-link">ecolab.service-now.com</a><br>
          Email: <a href="mailto:Ordertrackingsupport&#64;ecolab.com" class="email-link">Ordertrackingsupport&#64;ecolab.com</a>
          Territory Alignment :<a href="https://ecolab.service-now.com/now/nav/ui/classic/params/target/kb_view.do%3Fsysparm_article%3DKB0037131" target="_blank" class="support-link">ecolab.service-now.com</a><br>
        </li>
      </ul>
    </div>
</div>
      </div>

      <div *ngFor="let message of messages" 
           class="message"
           [ngClass]="{'user-message': message.type === 'user', 'bot-message': message.type === 'bot'}">
           
<div *ngIf="message.name" class="message-sender">
    {{ message.name }}
  </div>

        
        <div class="message-content" [ngClass]="getSentimentClass(message)">
          <div class="message-text">{{ message.content }}</div>
          
          <!-- Message metadata for bot responses -->
           


          <div *ngIf="message.name === 'Bot'" class="message-metadata ">
            <div class="metadata-row">
              {{message.name}}
              <span *ngIf="message.intent" class="intent-tag">{{ message.intent }}</span>
              <span *ngIf="message.confidence" 
                    class="confidence-indicator"
                    [style.color]="getConfidenceColor(message.confidence)">
                {{ (message.confidence * 100).toFixed(0) }}%
              </span>
            </div>
            <div *ngIf="message.analysis?.sentiment" class="sentiment-indicator">
              Sentiment: {{ message.analysis?.sentiment }}
            </div>
          </div>
        </div>
        
        <div class="message-timestamp">
          {{ formatTimestamp(message.timestamp) }}
        </div>
      </div>

      <!-- Typing indicator -->
      <div *ngIf="isTyping" class="message bot-message typing-message">
        <div class="message-content">
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <!-- Error message -->
      <div *ngIf="error" class="error-message">
        <div class="error-content">
          <span class="error-icon">⚠️</span>
          <span class="error-text">{{ error }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="input-container">
    <div class="demo-section">
            <div class="input-wrapper-3">
                <textarea 
                     [(ngModel)]="currentMessage"
                     (keypress)="onKeyPress($event)"
                      placeholder="Type a message..."
                    class="message-input-3"
                    rows="1"></textarea>
                
                <button class="send-button-3" (click)="sendMessage()" title="Send">
                    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M14.61 8H2.806l-1.78 5.342a.5.5 0 0 0 .684.612L14.61 8ZM2.806 7H14.61L1.71 1.046a.5.5 0 0 0-.684.612L2.806 7Z"></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>

  
    
    <!-- Quick Actions -->
    <!-- <div class="quick-actions" *ngIf="shouldShowQuickActions()">
      <button class="quick-action-btn" (click)="sendQuickMessage('help')">
        <span class="quick-icon">❓</span>
        Help
      </button>
      <button class="quick-action-btn" (click)="sendQuickMessage('business hours')">
        <span class="quick-icon">🕒</span>
        Hours
      </button>
      <button class="quick-action-btn" (click)="sendQuickMessage('how to track')">
        <span class="quick-icon">📍</span>
        Track
      </button>
    </div> -->
  </div>
</div>